import {useContext,useEffect,useState} from 'react';
import { useParams,useNavigate/*,useLocation*/ } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import AppContext from '../../AppContext';
import {uscall/*,getfirst*/} from '../../us';

const CreateCheckout=function(){
	const {productcode}=useParams();
	const navigate=useNavigate();
	const auth = useAuth();
	const appcontext = useContext(AppContext);
	const [canbuyedu,setCanBuyEdu]=useState(false);
	const [canbuyedu_checked,setCanBuyEduChecked]=useState(false);

	useEffect(() => {
		if(auth && auth.isAuthenticated);
		else 
			navigate('/login/?redirect='+encodeURIComponent(document.location.href));
	},[auth,navigate]);

    useEffect(() => {
		if(auth && auth.isAuthenticated && appcontext && appcontext.features && (!appcontext.features.bundle2026))return setCanBuyEdu(true);
		else return setCanBuyEdu(false);
	},[auth,appcontext]);
    useEffect(() => {
		if( appcontext && appcontext.features)setCanBuyEduChecked(true);
	},[appcontext]);

	useEffect(()=>{
		const cb=async function(){
			if(canbuyedu_checked){
				if(canbuyedu){
					const r=(await uscall(appcontext,auth,'order','order','order_create_with_product_code',encodeURIComponent(productcode)));
					if(r && typeof(r['error'])!='undefined'){
						alert(r.error.description);
						navigate(-1);
						return;
					}
					navigate('/checkout/'+encodeURIComponent(r.result)+'/');
				}else{
					alert('Funzione non disponibile');
					navigate(-1);
					return;
				}
			}
		};
		if(auth && auth.isAuthenticated && (!auth.isLoading) && (!auth.error) && auth.user && auth.user.access_token)
			cb();
	},[auth,navigate,appcontext,productcode,canbuyedu,canbuyedu_checked]);
};
export default CreateCheckout;
